import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "amani_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminApi = {
  login: (email, password) =>
    axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data),
  me: () => axios.get(`${API}/auth/me`, authHeader()).then((r) => r.data),
  listApplications: () =>
    axios.get(`${API}/applications`, authHeader()).then((r) => r.data),
  updateStatus: (id, status) =>
    axios.patch(`${API}/applications/${id}`, { status }, authHeader()).then((r) => r.data),
  remove: (id) =>
    axios.delete(`${API}/applications/${id}`, authHeader()).then((r) => r.data),
};
